import { useCallback } from 'react';
import { useAtomCallback } from 'jotai/utils';
import { createKPI, deleteKPI } from '../../../services/queries/KPIConfigQueries';
import { kpiConfigAtom } from '../../../services/state/KPIConfigState';
import { IField } from '../../../data-models/field2.data-model';
import { sortFields } from '../../../util/field-utils';
import { useToastMessageState } from '../../../components/ToastMessage/ToastMessageProvider';
import { getErrorMessage } from '../../../services/queryHelpers';

export function useKPIFieldActions() {
  const { pushErrorToast } = useToastMessageState();

  const addKPIField = useAtomCallback(
    useCallback(
      async (get, set, kpiField: IField<unknown>) => {
        try {
          const newKPI = await createKPI(kpiField);
          const current = await get(kpiConfigAtom);
          const newKPIs = [...current, newKPI].sort(sortFields);
          set(kpiConfigAtom, Promise.resolve(newKPIs));
        } catch (error) {
          pushErrorToast({ message: getErrorMessage(error, 'Failed to add KPI') });
        }
      },
      [pushErrorToast]
    )
  );

  const deleteKPIField = useAtomCallback(
    useCallback(
      async (get, set, kpiId: number) => {
        try {
          await deleteKPI(kpiId);
          const current = await get(kpiConfigAtom);
          set(kpiConfigAtom, Promise.resolve(current.filter((kpi) => kpi.id !== kpiId)));
        } catch (error) {
          pushErrorToast({ message: getErrorMessage(error, 'Failed to delete KPI') });
        }
      },
      [pushErrorToast]
    )
  );

  return {
    addKPI: addKPIField,
    deleteKPI: deleteKPIField,
  };
}
